import React from "react";
import { toast } from "react-toastify";
import correctImg from "../Assets/images/correct.svg";
import errorImg from "../Assets/images/error.svg";
import axios from 'axios';
import apiConstants from '../constans/apiConstants'
export const isMobile = () => {
  if (process.env.BROWSER || window) {
    const viewSize = window && window.innerWidth;
    if (viewSize < 768) {
      return true;
    }
    return false;
  }
};
export const agentCode = localStorage.getItem('agentCode');

const Msg = ({ closeToast, heading, message, icon }) => {

  return (<div className="toastMainWrap">
    <img src={icon ? icon : correctImg} alt="" />
    <p>{heading && <span>{heading}</span>} {message}</p>
  </div>)
}


export const toaster = (type, msg, heading) => {
  const text = msg || "Something went wrong !";
  switch (type) {
    case "success":
      toast.success(<Msg message={text} heading={heading} />);
      break;
    case "error":
      toast.error(<Msg message={text} heading={heading} icon={errorImg} />);
      break;
    case "warn":
      toast.warn(<Msg message={text} heading={heading} />);
      break;
    case "info":
      toast.info(<Msg message={text} heading={heading} />);
      break;
    default:
      toast.info(<Msg message={text} heading={heading} />);
  }
};

export const formateDate = (dv, type) => {
  if (!dv) {
    return null;
  } else {

    if (type === '-') {
      let dd = dv.getDate();
      let mm = dv.getMonth() + 1;
      let yyyy = dv.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    }
    else {
      let dd = String(dv.getDate()).padStart(2, "0");
      let mm = String(dv.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = dv.getFullYear();
      return `${dd}-${mm}-${yyyy}`
    }
  }
};
export const formateDateAndTime = (dv) => {
  if (!dv) {
    return null;
  } else {
    let dd = dv.getDate();
    let mm = dv.getMonth() + 1;
    let yyyy = dv.getFullYear();
    let hour = dv.getHours();
    let min = dv.getMinutes();
    let sec = dv.getSeconds();
    return `${dd}-${mm}-${yyyy} ${hour}:${min}:${sec}`;
  }
};

export const formateDateFormat = (dv) => {
  if (!dv) {
    return null;
  } else {
    var date = dv.split("-");
    let newdate = `${date[1]}/${date[0]}/${date[2]}`;
    return newdate;
  }
};

export const formatDateUS = (date) => {
  if (!date) return '';

  let parts;
  
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    // Format: YYYY-MM-DD
    parts = date.split('-');
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  } 
  
  if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
    // Format: DD-MM-YYYY
    parts = date.split('-');
    return `${parts[1]}/${parts[0]}/${parts[2]}`;
  }

  return '';
};

export const convertDateInFormat = (date, format) => {
  if (!date) return null;

  let d;

  if (date instanceof Date) {
    d = date;
  }
  else if (typeof date === "string") {
    if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(date)) {
      // YYYY-MM-DD
      const [y, m, day] = date.split("-");
      d = new Date(y, m - 1, day);
    } else if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(date)) {
      // DD-MM-YYYY
      const [day, m, y] = date.split("-");
      d = new Date(y, m - 1, day);
    } else {
      return null;
    }
  } else {
    return null;
  }

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  const sec = String(d.getSeconds()).padStart(2, "0");

  switch (format) {
    case "DD-MM-YYYY":
      return `${dd}-${mm}-${yyyy}`;

    case "MM/DD/YYYY":
      return `${mm}/${dd}/${yyyy}`;

    case "YYYY-MM-DD":
      return `${yyyy}-${mm}-${dd}`;

    case "DD-MM-YYYY HH:mm:ss":
      return `${dd}-${mm}-${yyyy} ${hh}:${min}:${sec}`;

    default:
      return `${dd}-${mm}-${yyyy}`; // safe fallback
  }
};



export const httpRequest = (path, data) => {
  return new Promise((resolve, reject) => {
    axios.post(`${path}`, data, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": localStorage.getItem('token')
      }
    }).then((res) => {
      resolve(res);
    }).catch((rej) => {
      reject(rej)
    })
  });
}
export const httpRequestGet = (path) => {
  return new Promise((resolve, reject) => {
    axios.get(`${path}`, {
      headers: {
        "Authorization": localStorage.getItem('token')
      }
    }).then((res) => {
      resolve(res);
    }).catch((rej) => {
      reject(rej)
    })
  });
}
export const httpRequestDownload = (path) => {
  return new Promise((resolve, reject) => {
    axios.get(`${path}`, {
      responseType: 'arraybuffer',
      headers: {
        "Authorization": localStorage.getItem('token'),
        "Accept": 'text/csv;charset=UTF-8'
      }
    }).then((res) => {
      resolve(res);
    }).catch((rej) => {
      reject(rej)
    })
  });
}
export const httpRequestDelete = (path, data) => {
  return new Promise((resolve, reject) => {
    axios.delete(`${path}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": localStorage.getItem('token')
      }
    }).then((res) => {
      resolve(res);
    }).catch((rej) => {
      reject(rej)
    })
  });
}

export const httpRequestNotoken = (path) => {
  return new Promise((resolve, reject) => {
    axios.post(`${apiConstants().PROPOSEL_API_URL}${path}`, {
      headers: {
        "Content-Type": "application/json",
      }
    }).then((res) => {
      resolve(res);
    }).catch((rej) => {
      reject(rej)
    })
  });
}
export const indianCurrencyFormat = (x) => {
  if (!x) {
    return x;
  } else {
    let xv = parseFloat(x.toString().replace(/,/g, ""));
    return xv.toLocaleString("en-IN").toString();
  }
};

export const indianCurrencyToNumber = (value) => {
  if(!value) return value;
  return parseFloat(value.toString().replace(/,/g, ""));
}

export const convertNumberToWords = (amount) => {
  if(!amount) return "";
  var words = new Array();
  words[0] = "";
  words[1] = "One";
  words[2] = "Two";
  words[3] = "Three";
  words[4] = "Four";
  words[5] = "Five";
  words[6] = "Six";
  words[7] = "Seven";
  words[8] = "Eight";
  words[9] = "Nine";
  words[10] = "Ten";
  words[11] = "Eleven";
  words[12] = "Twelve";
  words[13] = "Thirteen";
  words[14] = "Fourteen";
  words[15] = "Fifteen";
  words[16] = "Sixteen";
  words[17] = "Seventeen";
  words[18] = "Eighteen";
  words[19] = "Nineteen";
  words[20] = "Twenty";
  words[30] = "Thirty";
  words[40] = "Forty";
  words[50] = "Fifty";
  words[60] = "Sixty";
  words[70] = "Seventy";
  words[80] = "Eighty";
  words[90] = "Ninety";
  amount = amount.toString();
  var atemp = amount.split(".");
  var number = atemp[0].split(",").join("");
  var n_length = number.length;
  var words_string = "";
  if (n_length <= 9) {
    var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
    var received_n_array = new Array();
    for (let i = 0; i < n_length; i++) {
      received_n_array[i] = number.substr(i, 1);
    }
    for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
      n_array[i] = received_n_array[j];
    }
    for (let i = 0, j = 1; i < 9; i++, j++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        if (n_array[i] == 1) {
          n_array[j] = 10 + parseInt(n_array[j]);
          n_array[i] = 0;
        }
      }
    }
    let value = "";
    for (let i = 0; i < 9; i++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        value = n_array[i] * 10;
      } else {
        value = n_array[i];
      }
      if (value != 0) {
        words_string += words[value] + " ";
      }
      if (
        (i == 1 && value != 0) ||
        (i == 0 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Crores ";
      }
      if (
        (i == 3 && value != 0) ||
        (i == 2 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Lakhs ";
      }
      if (
        (i == 5 && value != 0) ||
        (i == 4 && value != 0 && n_array[i + 1] == 0)
      ) {
        words_string += "Thousand ";
      }
      if (i == 6 && value != 0 && n_array[i + 1] != 0 && n_array[i + 2] != 0) {
        words_string += "Hundred and ";
      } else if (i == 6 && value != 0) {
        words_string += "Hundred ";
      }
    }
    words_string = `${words_string && "Rupees "} ${words_string
      .split("  ")
      .join(" ")}`;
  }
  return words_string;
};

export const pastDate = (d, daysCount) => {
  if(!d || !daysCount) {
    return ""
  }
  let date = new Date(d)
  date.setDate(date.getDate() - daysCount);
  return date
}

export const getUserDetails = () => {
  let user = localStorage.getItem("userDetails")
  
  return JSON.parse(user);
}

export const formateENGBManually = (val,  secondFormat, thirdFormat) => {
  if(!val) {
    return null
  }
  var today = val;
  var day = today.getDate() + "";
  var month = (today.getMonth() + 1) + "";
  var year = today.getFullYear() + "";
  var hour = today.getHours() + "";
  var minutes = today.getMinutes() + "";
  var seconds = today.getSeconds() + "";
  function checkZero(data){
    if(data.length == 1){
      data = "0" + data;
    }
    return data;
  }

  day = checkZero(day);
  month = checkZero(month);
  year = checkZero(year);
  hour = checkZero(hour);
  minutes = checkZero(minutes);
  seconds = checkZero(seconds);
  if(secondFormat){
    return `${year}-${month}-${day}T`
  }
  if(thirdFormat){
    return `${day}-${month}-${year} ${hour}:${minutes}:${seconds}`
  }
  else{
    return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`
  }
}
export const formateDateManually = (val,  secondFormat) => {
  if(!val) {
    return null
  }
  let date = val.toString().split("-");
  var today = new Date(date[2], date[1] - 1, date[0]);
  var day = today.getDate() + "";
  var month = (today.getMonth() + 1) + "";
  var year = today.getFullYear() + "";
  var hour = today.getHours() + "";
  var minutes = today.getMinutes() + "";
  var seconds = today.getSeconds() + "";
  function checkZero(data){
    if(data.length == 1){
      data = "0" + data;
    }
    return data;
  }

  day = checkZero(day);
  month = checkZero(month);
  year = checkZero(year);
  hour = checkZero(hour);
  minutes = checkZero(minutes);
  seconds = checkZero(seconds);
  if(secondFormat){
    return `${year}-${month}-${day}T`
  }
  else{
    return `${day}-${month}-${year} ${hour}:${minutes}:${seconds}`
  }
}
export const getNextDate = (val,n) => {
  val = "2022-12-27T13:47:31"
  let date = new Date(val);
  date.setDate(date.getDate()+n);
  let y = date.getFullYear().toString();
  let m = (date.getMonth() + 1).toString();
  let d = date.getDate().toString();
  let hour = date.getHours();
  let min = date.getMinutes();
  let sec = date.getSeconds();
  return y + '-' + m + '-' + d+"T"+hour+":"+min+":"+sec;
}


